import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { semanticColors, greyScaleColors } from '../../../Globals/styles';
import Waves from 'node-waves'

class DeleteModal extends Component{
  constructor(props) {
    super(props);
    this.state = {
      boxOne: false,
      boxTwo: false,
      boxThree: false
    }
  }
  componentDidMount = () => {
    Waves.attach('.waves-btn', ['waves-button']);
    Waves.attach('.waves-icon', ['waves-circle']);
  };
  componentDidUpdate = () => {
    Waves.attach('.waves-btn', ['waves-button']);
    Waves.attach('.waves-icon', ['waves-circle']);
  };
  handleDelete = () => {
      this.props.deleteWorkplace()
  };

  render()  {
    const { boxOne, boxTwo, boxThree } = this.state;
    const { isLoading } = this.props;
    return (
      <div style={styles.container}>
          <div style={styles.overlay}></div>
            <div style={styles.modal}>
            {isLoading ?
              <div>
                <i className="fa fa-spinner fa-spin fa-3x" style={styles.spinner}/>
              </div>
              :
              <div>
                <i
                  className="fa fa-times waves-icon"
                  aria-hidden="true"
                  style={styles.closeIcon}
                  onClick={()=> this.props.closeDeleteModal(false)}></i>
                <div>
                  <div style={styles.heading}>Slet arbejdssted og indhold</div>
                  <div style={styles.subHeading}>for at slette arbejdssted skal du godkende nedenstående felter:</div>
                  <div style={styles.taskContainer}>
                    {boxOne ?
                      <i className="fa fa-check-square-o waves-icon" aria-hidden="true"
                        style={[styles.checkContainer, styles.red]}
                        onClick={()=>this.setState({boxOne: false})}></i>
                      :
                      <i className="fa fa-square-o waves-icon" aria-hidden="true"
                        style={styles.checkContainer}
                        onClick={()=>this.setState({boxOne: true})}></i>
                    }
                    <span style={[styles.checkText, boxOne ? styles.black : styles.red]}>slet alle dagrapporter</span>
                  </div>
                  <div style={styles.taskContainer}>
                    {boxTwo ?
                      <i className="fa fa-check-square-o waves-icon" aria-hidden="true"
                        style={[styles.checkContainer, styles.red]}
                        onClick={()=>this.setState({boxTwo: false})}></i>
                      :
                      <i className="fa fa-square-o waves-icon" aria-hidden="true"
                        style={styles.checkContainer}
                        onClick={()=>this.setState({boxTwo: true})}></i>
                    }
                    <span style={[styles.checkText, boxTwo ? styles.black : styles.red]}>slet alle timeregistreringer</span>
                  </div>
                  <div style={styles.taskContainer}>
                    {boxThree ?
                      <i className="fa fa-check-square-o waves-icon" aria-hidden="true"
                        style={[styles.checkContainer, styles.red]}
                        onClick={()=>this.setState({boxThree: false})}></i>
                      :
                      <i className="fa fa-square-o waves-icon" aria-hidden="true"
                        style={styles.checkContainer}
                        onClick={()=>this.setState({boxThree: true})}></i>
                    }
                    <span style={[styles.checkText, boxThree ? styles.black : styles.red]}>slet alle billeder</span>
                  </div>
                  <button
                    className="btn  waves-btn"
                    style={[styles.sletBtn,styles.undoBtn]}
                    onClick={()=> this.props.closeDeleteModal(false)}>
                      <i className="fa fa-undo" aria-hidden="true"></i> Fortryd
                  </button>
                  <button
                    className="btn waves-btn"
                    style={[styles.sletBtn, styles.disable, (boxOne && boxTwo && boxThree) && styles.deleteBtn]}
                    disabled={!(boxOne && boxTwo && boxThree)}
                    onClick={()=> this.handleDelete()}>
                     <i className="fa fa-trash-o" aria-hidden="true"></i>  Ok
                  </button>
                </div>
              </div>
              }
          </div>
      </div>
    );
  }
}


var styles = {
  container: {
    position: 'relative',
    zIndex: '100'
  },
  sletBtn: {
    color: '#fff',
    borderRadius: '2px',
    height: '35px',
    lineHeight: '35px',
    padding: '0px',
    width: '105px',
    marginTop: '20px',
    float: 'right',
    fontSize: '14px'
  },
  modal:{
    position: 'fixed',
    top: '50%',
    left: '50%',
    zIndex: '11',
    backgroundColor: semanticColors.default,
    width: '266px',
    height: '266px',
    marginTop: '-133px',
    marginLeft: '-133px',
    textAlign: 'center',
    borderRadius: '2px',
    lineHeight: '40px',
    padding: '20px 15px 15px 15px'

  },
  heading:{
    fontWeight: '600',
    fontSize: '14px',
    height: '25px',
    lineHeight: 'normal',
    borderBottom: '2px solid' + semanticColors.danger,
    marginBottom: '10px'
  },
  subHeading:{
    fontWeight: '600',
    fontSize: '12px',
    height: '25px',
    lineHeight: 'normal',
    marginBottom: '15px'
  },
  overlay: {
    width:'100%',
    height: '100%',
    position: 'fixed',
    top: '0',
    left: '0',
    backgroundColor: greyScaleColors.grey,
    opacity: '0.6',
    zIndex: '10'
  },
  closeIcon: {
    position: 'absolute',
    top: '0px',
    right: '0px',
    fontSize: '20px',
    height: '30px',
    lineHeight: '30px',
    width: '30px',
    zIndex: '10',
    cursor: 'pointer'
  },
  taskContainer: {
    position: 'relative',
    textAlign: 'left',
    width: '90%',
    margin: 'auto',
    paddingLeft: '40px',
    height: '35px',
    lineHeight: '30px',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    fontSize: '13px'
  },
  checkContainer: {
    position: 'absolute',
    left: '0px',
    fontSize: '20px',
    lineHeight: '35px',
    height: '35px',
    width: '35px',
    top: '0',
    textAlign: 'center',
    color: semanticColors.text
  },
  checkText:{
    fontSize: '12px'
  },
  red: {
    color: semanticColors.danger
  },
  black: {
    color: semanticColors.text
  },
  disable:{
    backgroundColor: greyScaleColors.greyLighter,
    color: greyScaleColors.grey
  },
  undoBtn: {
    backgroundColor: greyScaleColors.greyLight,
    float: 'left'
  },
  deleteBtn:{
    backgroundColor: semanticColors.danger,
    color: '#fff'
  },
  spinner : {
    width:'100px',
    color: greyScaleColors.greyLight,
    position: 'absolute',
    top:'50%',
    left: '50%',
    marginTop:'-50px',
    marginLeft: '-50px',
    fontSize: '70px',
    textAlign: 'center'
  }
}

  DeleteModal.propTypes = {
    isLoading: PropTypes.bool.isRequired
  };

export default Radium(DeleteModal)


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/Overview/deleteModal.jsx